import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { companyManagementUrl } from "../../../config";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { CompanyColumns } from "../../../data/DynamicTable/CompanyManagementColumns";
import { allCompanies } from "../../../data/Axios/queries";
import CompanyForm from "./form";
import { generateAndExecuteMutation } from "../../../data/Axios/DynamicService";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";

const base_url = companyManagementUrl.uri;

const ignoreFields = [
  "ContactEmail",
  "CompanyEmail",
  "ContactPhoneNumber",
  "ContactEmailPassword",
  "EmailClient",
  "EmailDisplayName",
  "EmailClientPortNumber",
  "ParentOffice",
  "ContactPerson",
  "PostalAddress",
  "OpeningDate",
  "SMSReminder",
  "PaymentReply",
  "RegistrationFee",
  "GroupRegistrationFee",
  "FSApiKey",
  "SubscriptionId",
  "LogoPath",
];

// Define tour steps for the Rights page
const companyTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Company Management page, where you can Creates, edit activate or deactivate the Company.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find specific Company by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new Comapny.",
    placement: "right",
  },
  // {
  //   target: ".dynamic-table-grid",
  //   content: "This table displays all rights. You can view and manage them here.",
  //   placement: "top",
  // },
  {
    target: ".dynamic-table-actions",
    content: "Select actions like Edit or Deactivate for each right from this dropdown.",
    placement: "left",
  },
];

const actions = {
  entity: "Companies",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    modelName: "companyIds",
    inputObjectName: "bulkActivateDeactivateCompany",
  },
  dataObject: {
    ignoreFields,
    objectName: "companies",
    parameters: "",
  },
  //required: "CompanyIds",
  showStatus: false,
  showMore:{
    search:false,
    min: 0,
    max:0
  }
};

function CompanyTable() {
 

  return (
    <Box m="2px">
      <DynamicTableForJson
        title="Company"
        subtitle="Create, view or edit account Company"
        FormComponent={CompanyForm}
        base_url={base_url}
        actions={actions}
                tourSteps={companyTourSteps} // Pass tour steps as prop
      />
    </Box>
  );
}

export default CompanyTable;
